import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@mui/lab';
import { Alert, Badge, Box, Button, Divider, Grid, IconButton, Paper, Stack, Typography, useMediaQuery} from '@mui/material';
import { format, formatDistance, parse } from 'date-fns';
import React, { useState } from 'react';
import useBSSLogger from "../../../../hooks/useBSSLogger";
import { commonFormats, distanzaDataTesto } from '../../../../lib/dateshelper';
import __t from '../../../../lib/traduzioni';
import { useInterval } from 'react-use';
import { grey } from '@mui/material/colors';
import { useTheme } from '@emotion/react';
const {logger} = useBSSLogger();

const propsFromData = ({DotProps = {}, ContentWrapper = Paper, ContentWrapperProps = {sx: {p: 2}}, Icon = null, data = null, children}) => {
    let distanzaData = null;
    let dataEvento = null;

    const stileNota = {backgroundColor: grey[400], color: "white"};

    const nomeicona = (data.statoordine?.iconatracking ?? null);
    let nomeiconareale = data.statoordine ? 'circle' : 'quote-right';
    if(nomeicona !== null){
        if(nomeicona.startsWith("fa")){
            nomeiconareale = nomeicona.split("fa fa-")[1]; 
        }
        if(nomeicona.startsWith("fas ")){
            nomeiconareale = nomeicona.split("fas fa-")[1]; 
        }
        if(nomeicona.startsWith("far ")){
            nomeiconareale = nomeicona.split("far fa-")[1]; 
        }
        if(nomeicona.startsWith("fab ")){
            nomeiconareale = nomeicona.split("fab fa-")[1]; 
        }
    }
    if(nomeiconareale !== null){
        //Icon = (<FontAwesomeIcon className="fa-fw" icon={nomeiconareale} />)
        Icon = (<i className={`fa-fw ${nomeicona}`} />)
    }

    if(data.statoordine){
        const stileStato = {color: data.statoordine?.coloretesto, backgroundColor: data.statoordine?.colorestato};
        DotProps = {...DotProps, sx: stileStato}
        ContentWrapperProps = {...ContentWrapperProps, sx: {...stileStato, ...ContentWrapperProps.sx}}
    }

    if(data.note){                        
        ContentWrapperProps = {...ContentWrapperProps, sx: {...stileNota, ...ContentWrapperProps.sx}}
    }
    

    if(data.dataevento !== null){
        dataEvento = format(parse(data.dataevento, commonFormats.JAVA2JS, new Date()), commonFormats.JSREADABLE);
        distanzaData = distanzaDataTesto({data: data.dataevento})
    }
    
    children = (
        <>
            <Stack>
                <Box>
                    {data.note ?? data.statoordine?.nomestato?.testo ?? children}
                </Box>
                {(dataEvento !== null) && (
                    <>  
                        <Box py={1}>
                            <Divider />
                        </Box>
                        <Box textAlign={"right"}>
                            <Typography variant="subtitle2">
                                <i>
                                    {distanzaData}
                                </i>
                            </Typography>
                        </Box>
                    </>
                )}
                
                
            </Stack>
            
        </>
    );

    return {
        children,
        dataEvento,
        distanzaData,
        stileNota,
        nomeiconareale,
        ContentWrapperProps,
        DotProps,
        Icon
    }
}

const ItemTracking = ({side = 'left', DotProps = {}, ContentWrapper = Paper, ContentWrapperProps = {sx: {p: 2}}, Icon = null, data = null, children}) => {
    
    let dataEvento = null;
    let distanzaData = null;
    let stileNota = null;
    let nomeiconareale = null;

    if(data !== null){

        const dataProps = propsFromData({data});

        children = dataProps.children;
        dataEvento = dataProps.dataEvento;
        distanzaData = dataProps.distanzaData;
        stileNota = dataProps.stileNota;
        nomeiconareale = dataProps.nomeiconareale;
        ContentWrapperProps = dataProps.ContentWrapperProps;
        DotProps = dataProps.DotProps;
        Icon = dataProps.Icon;
    
    }

    const ContentComp = (
        <ContentWrapper {...ContentWrapperProps}>
            <Typography sx={{fontWeight: "bold"}}>
                {children}
            </Typography>            
        </ContentWrapper>
    )

    const DotComp = (
        <TimelineDot {...DotProps}>
            {Icon && (
                <>
                    {Icon}
                </>
            )}                    
        </TimelineDot>
    )

    const DataComp = ((dataEvento !== null) && (
            
        <Typography variant='subtitle2' sx={{p: 2}}>
            {__t("aggiornatoil")} {dataEvento}
        </Typography>            

    ))

    let stileSinistra = {paddingLeft: 0};
    let stileDestra = {paddingRight: 0};
    const stileCentroVerticale = {margin: 'auto 0'}

    if(side === 'right'){
        stileSinistra = {...stileSinistra, ...stileCentroVerticale}
    } else {
        stileDestra = {...stileDestra, ...stileCentroVerticale}
    }

    return (
        <TimelineItem>
            <TimelineOppositeContent sx={{...stileSinistra}}>                                        
                {(side === 'left') && ContentComp}
                {(side === 'right') && DataComp}
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineConnector />
                {DotComp}
                <TimelineConnector />
            </TimelineSeparator>                                
            <TimelineContent sx={{...stileDestra}}>
                {(side === 'right') && ContentComp}
                {(side === 'left') && DataComp}
            </TimelineContent>
        </TimelineItem>
    )
}

const ItemTrackingPhone = ({side = 'left', DotProps = {}, ContentWrapper = Paper, ContentWrapperProps = {sx: {p: 2}}, Icon = null, data = null, children}) => {
    
    let dataEvento = null;
    let distanzaData = null;
    let stileNota = null;
    let nomeiconareale = null;

    if(data !== null){

        const dataProps = propsFromData({data});

        children = dataProps.children;
        dataEvento = dataProps.dataEvento;
        distanzaData = dataProps.distanzaData;
        stileNota = dataProps.stileNota;
        nomeiconareale = dataProps.nomeiconareale;
        ContentWrapperProps = dataProps.ContentWrapperProps;
        DotProps = dataProps.DotProps;
        Icon = dataProps.Icon;
    
    }

    return (
        <>            
            <ContentWrapper {...ContentWrapperProps}>
                <Typography sx={{fontWeight: "bold"}}>
                    <Stack>
                        
                        <Box textAlign={"right"}>
                            {Icon} 
                        </Box>

                        <Box py={1}>
                            <Divider />
                        </Box>

                        <Box>
                            {children}
                        </Box>                        
                    </Stack>                                                            
                </Typography>            
            </ContentWrapper>            
        </>
    )
}

const dateToTimestamp = (data) => {
    return format(parse(data, commonFormats.JAVA2JS, new Date()), commonFormats.SECONDSTIMESTAMP)
}

const CenterVerticalDivider = ({sx = null}) => {

    const defaultSx = {width: 1/2, height: 20, borderRight: `2px solid ${grey[400]}`, mb: 1}

    if(sx === null) {
        sx = {...defaultSx};
    } else {
        sx = {...defaultSx, ...sx}
    }

    return(
        <Box {...sx}></Box>
    )
}

const TabTracking = ({ordine, tabObj}) => {

    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down("lg"));

    useInterval(()=>{
        logger.debug("aggiorno componente tracking", new Date())
    }, 60000)

    const [ordineEventi, setOrdineEventi] = useState("asc")

    const {storicoeventi = []} = ordine;

    let lato = 'left';

    const eventiOrdinati = [
        ...storicoeventi,        
    ]
    .sort((a, b) => {
        const timea = dateToTimestamp(a.dataevento);
        const timeb = dateToTimestamp(b.dataevento);
        return (ordineEventi === "asc") ? 
            (timea - timeb) :
            (timeb - timea);
    });

    let ultimoEvento = null;

    if(Array.isArray(storicoeventi) && storicoeventi.length){
        ultimoEvento = eventiOrdinati[ordineEventi === 'desc' ? 0 : (eventiOrdinati.length - 1)]
        ultimoEvento.distanza = distanzaDataTesto({data: ultimoEvento.dataevento});
    }
    

    return (
        <>
            <Grid item xs={12}>
                                
                {(Array.isArray(storicoeventi) && storicoeventi.length) ? ( 
                    <>
                        <Box display={"flex"}>
                            <Box flexGrow={1} sx={{margin: 'auto 0'}}>
                                <Typography variant="subtitle2">
                                    {storicoeventi.length} {__t("aggiornamenti")}. {__t("ultimorisalea")} {ultimoEvento.distanza}
                                </Typography>
                            </Box>
                            <Box w={1} textAlign={"right"}>
                                {(isPhone) ? (
                                    <IconButton onClick={e => setOrdineEventi(ordineEventi === 'asc' ? 'desc' : 'asc')}>
                                        {ordineEventi === 'asc' ? (<ArrowDropUp />) : (<ArrowDropDown />)}
                                    </IconButton>
                                ): (
                                    <Button 
                                        variant="contained" 
                                        endIcon={ordineEventi === 'asc' ? (<ArrowDropUp />) : (<ArrowDropDown />)}
                                        onClick={e => setOrdineEventi(ordineEventi === 'asc' ? 'desc' : 'asc')}
                                    >
                                        {__t("ordine")}: {__t(ordineEventi === 'asc' ? "damenorecente" : "dapiurecente")}
                                    </Button>
                                )}
                                
                            </Box>
                        </Box>

                    

                        <Box py={1}>
                            <Divider />
                        </Box>
                        
                        {!isPhone && (
                            <Timeline position="right" sx={{padding: 0}}>

                                {eventiOrdinati.map((evento, indiceEvento) => {

                                    
                                    if(![null, undefined].includes(evento?.lato?.value ?? null)){
                                        lato = evento.lato.value.toLowerCase();
                                    } else {
                                        if(lato === 'left'){
                                            lato = 'right';
                                        } else {
                                            lato = 'left';
                                        }
                                    }
                                    

                                    

                                    return (
                                        <ItemTracking key={evento.id} side={lato} data={evento} />
                                    )
                                })}

                            </Timeline>
                        )}

                        {isPhone && (
                            <>
                            {eventiOrdinati.map((evento, indiceEvento) => {

                                    return (
                                        <Stack key={evento.id} width={1}>                                            
                                            <CenterVerticalDivider />
                                            <ItemTrackingPhone data={evento} />
                                            <CenterVerticalDivider sx={{mb: 0, mt: 1}} />                                            
                                        </Stack>
                                        
                                    )
                                })}
                            </>
                        )}
                        
                    </>
                ) : (
                    <Alert severity='info'>
                        {__t("nessunaggiornamento")}
                    </Alert>
                )}

                
            </Grid>             
        </>
    )
}

export default TabTracking